<template>
    <div class="corporate_legal_affairs">
        <div class="cla_felx">
            <div class="cla_lefts">
                <div class="title_box">
                    <div class="title_text1">企业法务</div>
                    <div class="title_text2">CORPORATE LAW</div>
                    <div class="title_img">
                        <img src="../../assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="tab_box">
                    <div class="tab_list">
                        <div class="tab_item" :class="{tab_item_ac:item.id==tab_item_ac}" v-for="(item,index) in tab_list" :key="index" @click="handle_item(item,index)" v-if="index<6">
                            <div class="item_text">{{ item.title }}</div>
                            <div class="item_border"></div>
                        </div>
                    </div>
                    <div class="tab_btns">
                        <div class="btns" @click="$router.push('/enterprise_list')">服务入口</div>
                    </div>
                </div>
                <div class="new_list">
                    <div class="new_items" v-for="(item,index) in lists" :key="index" @click="handle_qy_deial(item)">
                        <div class="itme_title">
                            {{ item.title }}
                        </div>
                        <div class="item_const">
                            {{ item.desc }}
                        </div>
                        <div class="price_num">
                            <div class="price">￥{{ item.price }}</div>
                            <div class="num">销量 {{ item.sale_num }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cla_rights">
                <div class="title_box">
                    <div class="title_text1">个人法务</div>
                    <div class="title_text2">PERSONAL LEGAL</div>
                    <div class="title_img">
                        <img src="../../assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="text_btns_box">
                    <div class="text_box">个人法务</div>
                    <div class="btns_box">
                        <div class="btns" @click="$router.push('/individual_list')">服务入口</div>
                    </div>
                </div>
                <div class="type_list">
                    <div class="type_itme" v-for="(item,index) in type_list" :key="index" @click="handle_type_path(item)">
                        <div class="type_img">
                            <img :src="item.icon" alt="">
                        </div>
                        <div class="type_text">
                            {{ item.title }}
                        </div>
                    </div>
                    <div class="type_itme2" v-for="(item,index) in 9"  ></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            tab_item_ac:0,
            tab_list:[],
            lists:[],
            type_list:[],
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_tab_list()
        this.get_type_list()
    },
    methods: {
        handle_item(item,index){
            this.tab_item_ac=item.id
            this.get_lists()
        },
        get_tab_list(){
            this.loading=true
            this.$api("cause", {
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('企业法务分类',res)
                if (res.code == 1) {
                   this.tab_list=res.data
                   if(res.data.length>0){
                        this.tab_item_ac=res.data[0].id
                        this.get_lists()
                    }
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_type_list(){
            this.loading=true
            this.$api("cause", {
				type:2,
                
			}, "get").then((res) => {
                this.loading = false
                console.log('个人法务分类',res)
                if (res.code == 1) {
                   this.type_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
         
        },
        get_lists(){
            this.loading=true
            this.$api("servePros", {
                limit:6,
                cateid:this.tab_item_ac,
                type:2,
			}, "get").then((res) => {
                this.loading = false
                console.log('企业法务列表',res.data)
                if (res.code == 1) {
                   this.lists=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_type_path(item){
            this.$router.push({
                path:'/individual_list',
                query:{
                    id:item.id
                }
            })
        },
        handle_qy_deial(item){
            this.$router.push({
                path:'/enterprise_detial',
                query:{
                    id:item.id
                }
            })
        },



    },

}
</script>
<style scoped lang="less">
.corporate_legal_affairs{
    padding: 104px 0;
    background-color: #F6F8FF;
    .cla_felx{
        width: 1440px;
        // height: 100px;
        // background: red;
        display: flex;
        // align-items: center;
        justify-content: space-between;
        margin: auto;
        .cla_lefts{
            width: 950px;
            .title_box{
                display: flex;
                align-items: end;

                // align-content: end;
                // justify-content: space-between;
                .title_text1 {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 36px;
                    color: #333333;

                }

                .title_text2 {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 24px;
                    color: #377CFD;
                    margin-left: 16px;
                }

                .title_img {
                    width: 24px;
                    height: 24px;
                    margin-left: 16px;

                    img {
                        width: 24px;
                        height: 24px;
                    }
                }
                
            }
            .tab_box{
                display:flex;
                align-items: center;
                justify-content: space-between;
                padding-top: 32px;
                border-bottom: 2px solid #EDEDED;

                .tab_list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .tab_item{
                        margin-right: 40px;
                        cursor: pointer;
                        padding-top: 16px;
                        .item_text{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 18px;
                            color: #999999;

                        }
                        .item_border{
                            margin-top: 18px;
                            width: 72px;
                            height: 3px;
                            background: #F6F8FF;
                            border-radius: 0px 0px 0px 0px;
                        }
                        &:hover{
                            .item_text{
                                color: #377CFD;
                            }
                            .item_border{
                                background: #377CFD;
                            }
                        }
                    }
                    .tab_item_ac{
                        .item_text{
                                color: #377CFD;
                            }
                            .item_border{
                                background: #377CFD;
                            }
                    }
                }
                .tab_btns{
                    .btns{
                        width: 180px;
                        height: 40px;
                        background: #377CFD;
                        border-radius: 20px 20px 20px 20px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 40px;
                        cursor: pointer;
                    }
                }
            }
            .new_list{
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                .new_items{
                    width: 453px;
                    height: 240px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 40px 1px rgba(43,89,255,0.08);
                    border-radius: 8px 8px 8px 8px;
                    margin-top: 40px;
                    cursor: pointer;
                    padding: 32px 40px;
                    .itme_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 20px;
                        color: #333333;
                    }
                    .item_const{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        padding-top: 20px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        min-height: 57px;
                    }
                    .price_num{
                        margin-top: 24px;
                        padding-top: 23px;
                        border-top: 2px solid #EDEDED;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .price{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 32px;
                            color: #FD4C5C;
                        }
                        .num{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                        }
                    }
                }
            }   
        }
        .cla_rights{
            width: 450px;
            .title_box{
                display: flex;
                align-items: end;

                // align-content: end;
                // justify-content: space-between;
                .title_text1 {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 36px;
                    color: #333333;

                }

                .title_text2 {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 24px;
                    color: #377CFD;
                    margin-left: 16px;
                }

                .title_img {
                    width: 24px;
                    height: 24px;
                    margin-left: 16px;

                    img {
                        width: 24px;
                        height: 24px;
                    }
                }
                
            }
            .text_btns_box{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 32px;
                padding-top: 16px;
                padding-bottom: 6px;
                .text_box{
                    
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #999999;

                }
                .btns_box{
                    width: 180px;
                    height: 40px;
                    background: #377CFD;
                    border-radius: 20px 20px 20px 20px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                }
            }
            .type_list{
                margin-top: 40px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                width: 453px;
                height: 520px;
                background: #FFFFFF;
                box-shadow: 0px 0px 40px 1px rgba(55,124,253,0.08);
                border-radius: 8px 8px 8px 8px;
                .type_itme2{
                    width: 150px;
                    height: 130px;
                }
                .type_itme{
                    width: 150px;
                    height: 130px;
                    display: flex;
                    // align-items: center;
                    align-content: center;
                    justify-content: center;
                    flex-wrap: wrap;
                    cursor: pointer;
                    border-bottom: 2px solid #F2F2F2;
                    border-right: 2px solid #F2F2F2;
                    .type_img{
                        width: 100%;
                        text-align: center;
                        img{
                        //    width: 48px;
                        //    height: 48px;
                           margin: auto;
                        }
                    }
                    .type_text{
                        width: 100%;
                        text-align: center;
                        padding-top: 6px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;

                    }
              
                }
                .type_itme:nth-child(3n){
                    border-right: 0;

                }
            }

        }
    }
    
}
</style>